import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../types'

const selectCatalogState = (state: RootState) => state.catalog

/**
 * Selector para obter listagem de baterias
 */
export const selectBatteries = createSelector(
  [selectCatalogState],
  (catalog) => catalog.batteries
)

/**
 * Selector para obter filtros atuais
 */
export const selectFilters = createSelector(
  [selectCatalogState],
  (catalog) => catalog.filters
)

/**
 * Selector para obter paginação
 */
export const selectPagination = createSelector(
  [selectCatalogState],
  (catalog) => catalog.pagination
)

/**
 * Selector para verificar se está carregando listagem
 */
export const selectListLoading = createSelector(
  [selectCatalogState],
  (catalog) => catalog.listLoading
)

/**
 * Selector para obter erro da listagem
 */
export const selectListError = createSelector(
  [selectCatalogState],
  (catalog) => catalog.listError
)

/**
 * Selector para obter bateria do cache por ID ou slug
 */
export const selectBatteryById = (idOrSlug: string) =>
  createSelector(
    [selectCatalogState],
    (catalog) => catalog.batteryCache[idOrSlug] || null
  )

/**
 * Selector para obter bateria atual
 */
export const selectCurrentBattery = createSelector(
  [selectCatalogState],
  (catalog) => {
    if (!catalog.currentBatteryId) return null
    return catalog.batteryCache[catalog.currentBatteryId] || null
  }
)

/**
 * Selector para verificar se está carregando bateria
 */
export const selectBatteryLoading = createSelector(
  [selectCatalogState],
  (catalog) => catalog.batteryLoading
)

/**
 * Selector para obter erro ao carregar bateria
 */
export const selectBatteryError = createSelector(
  [selectCatalogState],
  (catalog) => catalog.batteryError
)

/**
 * Selector para obter baterias em destaque
 */
export const selectFeaturedBatteries = createSelector(
  [selectCatalogState],
  (catalog) => catalog.featuredBatteries
)

/**
 * Selector para verificar se está carregando baterias em destaque
 */
export const selectFeaturedLoading = createSelector(
  [selectCatalogState],
  (catalog) => catalog.featuredLoading
)

/**
 * Selector para obter resultados de busca
 */
export const selectSearchResults = createSelector(
  [selectCatalogState],
  (catalog) => catalog.searchResults
)

/**
 * Selector para obter sugestões de busca
 */
export const selectSearchSuggestions = createSelector(
  [selectCatalogState],
  (catalog) => catalog.searchSuggestions
)

